var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPlay = function SvgFadPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "32 32 192 192",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.437 70.402c0-3.83 4.793-7.404 7.563-5.023 2.77 2.38 97.488 56.573 100.938 58.861 3.449 2.288 3.694 5.95 0 7.388-3.695 1.437-96.717 56.92-101.217 59.14-4.5 2.22-7.73-1.52-7.5-5.244.14-2.27.216-112.628.216-115.122z",
    fill: "#0F0",
    fillRule: "evenodd"
  })));
};
export { SvgFadPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-play.c7562321.svg";